import { Steps } from '@chakra-ui/react'
import React from 'react'
import { StepperVariant } from '~/components/defaults/componentStyles/Stepper.style'

export interface EventHistoryProps {
  children: React.ReactNode
  orientation?: 'horizontal' | 'vertical'
  variant?: string
  [key: string]: any
}

/** Drops the tab semantics `Steps` adds so the history reads as a plain list. */
const OrderedList = React.forwardRef<
  HTMLOListElement,
  React.ComponentProps<'ol'>
>(function OrderedList(
  { role: _role, 'aria-orientation': _orientation, ...props },
  ref,
) {
  return <ol ref={ref} {...props} />
})

const ListItem = React.forwardRef<HTMLLIElement, React.ComponentProps<'li'>>(
  function ListItem({ role: _role, ...props }, ref) {
    return <li ref={ref} {...props} />
  },
)

export const EventHistory = ({
  children,
  orientation = 'vertical',
  variant,
  ...rest
}: EventHistoryProps) => {
  const childrenCount = React.Children.count(children)
  return (
    <Steps.Root
      orientation={orientation}
      variant={(variant || StepperVariant.EventHistory) as any}
      step={childrenCount > 0 ? childrenCount - 1 : 0}
      count={childrenCount}
      {...rest}
    >
      <Steps.List asChild>
        <OrderedList>{children}</OrderedList>
      </Steps.List>
    </Steps.Root>
  )
}

interface EventHistoryStepProps {
  children: React.ReactNode
  index?: number
}

export const EventHistoryStep = ({
  children,
  index = 0,
}: EventHistoryStepProps) => {
  return (
    <Steps.Item index={index} asChild>
      <ListItem>
        <Steps.Indicator aria-hidden />
        <Steps.Separator aria-hidden />
        {children}
      </ListItem>
    </Steps.Item>
  )
}
